import React from "react";
import { useLang } from "../context/LanguageContext";
import { useImages } from "../hooks/useImages";
import { venueImages } from "../lib/i18n";

const FALLBACK_GALLERY = [
  { id: "fb1", src: venueImages.interior1, alt: "Innenbereich" },
  { id: "fb2", src: venueImages.exterior, alt: "Außenbereich" },
  { id: "fb3", src: venueImages.coffee, alt: "Cappuccino" },
  { id: "fb4", src: venueImages.interior2, alt: "Caffè-Bar" },
  { id: "fb5", src: venueImages.dish1, alt: "Gericht" },
  { id: "fb6", src: venueImages.interior3, alt: "Atmosphäre" },
  { id: "fb7", src: venueImages.dish2, alt: "Pasta" },
  { id: "fb8", src: venueImages.hero, alt: "Foto" },
];

const LAYOUT = [
  "col-span-12 md:col-span-7 row-span-2 aspect-[4/5] md:aspect-[5/6]",
  "col-span-12 md:col-span-5 aspect-[5/4]",
  "col-span-6 md:col-span-5 aspect-[5/4]",
  "col-span-6 md:col-span-4 aspect-[5/6]",
  "col-span-12 md:col-span-8 aspect-[16/9]",
  "col-span-12 md:col-span-4 aspect-[5/6]",
  "col-span-6 md:col-span-6 aspect-[4/3]",
  "col-span-6 md:col-span-6 aspect-[4/3]",
  "col-span-12 md:col-span-7 aspect-[16/9]",
  "col-span-12 md:col-span-5 aspect-[5/4]",
  "col-span-6 md:col-span-4 aspect-[4/3]",
  "col-span-6 md:col-span-4 aspect-[4/3]",
];

const Gallery = ({ compact = false }) => {
  const { t } = useLang();
  const { bySlot } = useImages();
  const fromApi = bySlot("gallery");
  const all = fromApi.length > 0 ? fromApi : FALLBACK_GALLERY;
  const images = compact ? all.slice(0, 6) : all;

  return (
    <section data-testid="gallery-section" className="py-24 lg:py-32 bg-[color:var(--ivory-2)]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 lg:gap-12 mb-16 items-end">
          <div className="col-span-12 md:col-span-8">
            <p className="overline text-[color:var(--wine)] flex items-center">
              <span className="section-line"></span>
              {t.gallery.eyebrow}
            </p>
            <h2 className="mt-6 font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              {t.gallery.title}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4">
            <p className="text-[color:var(--ink-2)] leading-relaxed">{t.gallery.subtitle}</p>
          </div>
        </div>

        {images.length === 0 ? (
          <p className="text-[color:var(--ink-3)] italic">—</p>
        ) : (
          <div className="grid grid-cols-12 gap-4 lg:gap-6">
            {images.map((img, i) => {
              const cls = LAYOUT[i % LAYOUT.length];
              return (
                <div
                  key={img.id}
                  data-testid={`gallery-item-${i}`}
                  className={`${cls.split(" aspect-")[0]} overflow-hidden group`}
                >
                  <div className={`aspect-${cls.split(" aspect-")[1]} w-full overflow-hidden`}>
                    <img
                      src={img.src}
                      alt={img.alt || ""}
                      className="w-full h-full object-cover smooth-image"
                      loading="lazy"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
